var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('sidebar-menu'),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('topbar'),_vm._v(" "),_c('main',{staticClass:"main-content"},[_c('div',{attrs:{"id":"mainContent"}},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f2e021","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Frame.vue
// module id = null
// module chunks = 